import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BadgeModule } from 'primeng/badge';
import { Nullable } from 'primeng/ts-helpers';
import { BehaviorSubject } from 'rxjs';
import { Severity } from '../../../contract/severity.contract';
import { IconColor } from './contract/icon-color.contract';
import { IconSize } from './contract/icon-size.contract';
import { IconWeight } from './contract/icon-weight.contract';
import { ICON_COLORS, ICON_COLORS_HOVER, ICON_SIZES, ICON_WEIGHTS } from './icon.constant';

@Component({
  selector: 'osp-icon',
  standalone: true,
  imports: [CommonModule, BadgeModule, FontAwesomeModule],
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent implements OnChanges {
  @HostBinding('class.osp-icon') protected hostCssClassEnabled = true;
  @HostBinding('class.p-component')

  @Input() iconSize: IconSize = 'medium';
  @Input() iconColor: IconColor | Nullable;
  @Input() iconColorHover: IconColor | Nullable;
  @Input() iconWeight: IconWeight | Nullable;
  @Input() icon = '';
  @Input() value: string | number | Nullable;
  @Input() severity: Severity;
  @Input() cssClass: string = '';

  protected classes = new BehaviorSubject('');

  ngOnChanges(): void {
    this.classes.next(this.getClasses());
  }

  private getClasses(): string {
    const classes = [
      ICON_SIZES[this.iconSize] || '',
      this.iconColor ? ICON_COLORS[this.iconColor] : '',
      this.iconColorHover ? ICON_COLORS_HOVER[this.iconColorHover] : '',
      this.iconWeight ? ICON_WEIGHTS[this.iconWeight] : '',
      this.cssClass,
      this.icon,
      'p-component',    // this class is necessary for a specific workflow of the tooltip directive
    ];

    return classes.filter((cssClass) => !!cssClass).join(' ');
  }
}
